import { FileInput } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';

const FileUpload = ({ label, onFileSet }) => {
  return (
    <FileInput
      label={label || 'Upload File to import'}
      placeholder="Click to select file"
      leftSection={<IconUpload size={16} />}
      onChange={(file) => onFileSet(file ? [file] : [])}
      data-tour="uploadFileToImportProfiles"
    />
  );
};

export default FileUpload;
